import React from 'react';
import { DrawSetting } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';

import DrawControlsLabel from './DrawControlsLabel';
import Slider from '../../../components/slider/Slider';
import useAppState from '../../../AppStore';

interface Props {
  slider: Exclude<
    DrawSetting,
    DrawSetting.Color | DrawSetting.DisplayTooltip | DrawSetting.FilledOut
  >;
}

const DrawSlider = ({ slider }: Props) => {
  const { t } = useTranslation('agisviewer');

  const selectedFeatureId = useAppState((state) => state.selectedFeatureId);
  const drawFeatures = useAppState((state) => state.drawFeatures);
  const editDrawFeature = useAppState((state) => state.editDrawFeature);
  const setDrawSetting = useAppState((state) => state.setDrawSetting);
  const feature = drawFeatures.find(({ id }) => id === selectedFeatureId)!;

  const drawSettings = feature.properties.settings;

  const getLabel = () => {
    switch (slider) {
      case DrawSetting.FontSize:
        return t('draw_control_size');
      case DrawSetting.StrokeWidth:
        return t('draw_control_stroke_width');
      case DrawSetting.Opacity:
        return t('draw_control_opacity');
      case DrawSetting.Radius:
        return feature.properties.type === 'dot'
          ? t('draw_control_size')
          : t('draw_control_radius');
      default:
        return '';
    }
  };

  const setDrawSliderValue = (value: number) => {
    editDrawFeature(feature.id as string, {
      properties: { settings: { [slider]: value } },
    });
    setDrawSetting(slider, value);
  };

  const value = drawSettings[slider];

  const opacityColor =
    slider === DrawSetting.Opacity ? drawSettings[DrawSetting.Color] : undefined;

  return (
    <div>
      <DrawControlsLabel>{getLabel()}</DrawControlsLabel>
      <Slider
        value={value}
        onChange={(newValue) => setDrawSliderValue(newValue)}
        opacityColor={opacityColor}
      />
    </div>
  );
};

export default DrawSlider;
